<template>
  <main class="auth-page">
    <section class="auth-showcase">
      <router-link to="/" class="brand" aria-label="123Mail">
        <img src="@/assets/img/icon.png" alt="" />
        <span>123MAIL</span>
      </router-link>
      <div class="showcase-copy">
        <span class="eyebrow">Marketing que se conecta</span>
        <h1>Transforme contatos em relacionamentos.</h1>
        <p>Gerencie campanhas, automações e seu CRM em uma plataforma simples e eficiente.</p>
        <div class="feature-list">
          <span><i class="fas fa-check"></i> Campanhas inteligentes</span>
          <span><i class="fas fa-check"></i> Automações em poucos cliques</span>
          <span><i class="fas fa-check"></i> Dados centralizados</span>
        </div>
      </div>
      <p class="showcase-footer">© {{ new Date().getFullYear() }} 123Mail</p>
    </section>

    <section class="auth-panel">
      <div class="auth-card">
        <div class="mobile-brand">
          <img src="@/assets/img/icon.png" alt="" />
          <strong>123MAIL</strong>
        </div>

        <div v-if="customerNew" class="welcome-alert" role="status">
          <i class="fas fa-check-circle"></i>
          <div>
            <strong>Compra confirmada!</strong>
            <p>Enviamos seus dados de acesso para o e-mail usado na compra.</p>
          </div>
        </div>

        <header class="auth-header">
          <span class="eyebrow">Bem-vindo de volta</span>
          <h2>Acesse sua conta</h2>
          <p>Entre com seu e-mail e senha para continuar.</p>
        </header>

        <form @submit.prevent="login" novalidate>
          <div class="field">
            <label for="login-email">E-mail</label>
            <div class="input-shell">
              <i class="far fa-envelope"></i>
              <input id="login-email" v-model="email" type="email" autocomplete="email" placeholder="voce@empresa.com.br" />
            </div>
          </div>

          <div class="field">
            <div class="label-row">
              <label for="login-password">Senha</label>
              <router-link to="/recovery-password">Esqueci minha senha</router-link>
            </div>
            <div class="input-shell">
              <i class="fas fa-lock"></i>
              <input id="login-password" v-model="password" :type="showPassword ? 'text' : 'password'" autocomplete="current-password" placeholder="Digite sua senha" />
              <button type="button" class="password-toggle" :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'" @click="showPassword = !showPassword">
                <i :class="showPassword ? 'far fa-eye-slash' : 'far fa-eye'"></i>
              </button>
            </div>
          </div>

          <button ref="buttonlogin" type="submit" class="submit-button" :disabled="loading">
            <i v-if="loading" class="fas fa-circle-notch fa-spin"></i>
            <span>{{ loading ? 'Entrando...' : 'Entrar na plataforma' }}</span>
            <i v-if="!loading" class="fas fa-arrow-right"></i>
          </button>
        </form>

        <p class="auth-switch">Ainda não possui uma conta? <router-link to="/register">Criar conta grátis</router-link></p>
      </div>
    </section>
  </main>
</template>

<script>
import { 
  login,
  checkIsLogged
} from "@/services/auth";
import {
  initFacebookLoginOauth2,
  initGoogleLoginOauth2,
} from "@/services/integration";
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      customerNew: false,
      loading: false,
      showPassword: false,
      timerToRequest: 3000,
      detectTokenDataOauth: null,

    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    this.customerNew = params.get('customer_new')

    if (this.customerNew) {
      // fb event
      const fbq = window.fbq;
      if (fbq) {
        fbq("track", "Purchase", {});
      }
    }

    if (this.$route.query.d) {
      this.email = "demonstracao@lucreihoje.com.br";
      this.password = "demo1234";

      this.$refs.buttonlogin.click()
    }
  },
  methods: {
    login() {
      if (this.loading) return;
      if (!this.email || !this.password) {
        this.$toast.error({
          title:'Erro',
          message:'Você deve preencher o email e senha para acessar'
        })

        return
      }

      let params = {
        username: this.email.trim(),
        password: this.password.trim()
      }

      this.loading = true;
      login(params).then(
        (result) => {
          this.$store.dispatch("auth", { token: result.token });

          this.$router.push({ name: "Account" });
        }
      )
      .catch(() => {
        this.$toast.error({
          title:'Erro',
          message:'Usuário ou senha errados'
        })
      })
      .finally(() => {
        this.loading = false;
      })
    },
    trackingEvents() {
      // fb event
      const fbq = window.fbq;
      if (fbq) {
        fbq("track", "Lead");
      }
    },
    checkIsLogged() {
      checkIsLogged()
        .then(() => {

          this.trackingEvents();

          clearInterval(this.detectTokenDataOauth)
          setTimeout(function() {
            location.reload(true);
          }, 1500)
        })
    },
    createLoginGoogleOauth2() {
      initGoogleLoginOauth2()
        .then((result) => {
          // set interval to refresh screen to get data
          this.detectTokenDataOauth = setInterval(() => {
            this.checkIsLogged(true);
          }, this.timerToRequest);

          this.win = window.open(
            result.url,
            "Oauth2",
            "resizable,height=800,width=600"
          );
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao iniciar oauth",
          });
        });
    },
    createLoginFacebookOauth2() {
      initFacebookLoginOauth2()
        .then((result) => {
          // set interval to refresh screen to get data
          this.detectTokenDataOauth = setInterval(() => {
            this.checkIsLogged(true);
          }, this.timerToRequest);

          this.win = window.open(
            result.url,
            "Oauth2",
            "resizable,height=800,width=600"
          );
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao iniciar oauth",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./auth-shared";
</style>
